import React from "react";
import "./SearchFilter.css";
import Search from "@material-ui/icons/Search";

function SearchFilter(props) {
  return (
    <div className="input-icons-filter">
      <Search className="icon-filter" />
      <input
        type="text"
        {...props}
        autoComplete="off"
        name="search"
        className="input-search-filter"
        id="search"
      />
    </div>
  );
}
export default SearchFilter;
